export default "__VITE_ASSET__DocrQWXY__"